import { Request } from "./clientHelper";

const API_BASE_URL = process.env.REACT_APP_DATA_SERVICE_URL;

export class JobService {

	static saveJob(data) {
		let uri = API_BASE_URL + "/jobs/" + data.dataModelId;
		let method = "POST"

		if (data.documentId) {
			uri += `/${data.documentId}`;
			method = "PUT"
			if (data?.data?._id) delete data.data._id;
		}

		return Request(uri, {
			url: uri,
			method: method,
			headers: {
				appId: data.appid,
			},
			payload: data.data,
		}).then(response => {
			return response
		}).catch(error => {
			console.error("error in update doc ===", error);
			return error;
		});
	}

	static getJob(data) {
		let uri = API_BASE_URL + "/jobs/" + data.dataModelId + `/${data.documentId}`;

		return Request(uri, {
			url: uri,
			method: "GET",
			headers: {
				appId: data.appid,
			}
		}).then(response => {
			return response
		}).catch(error => {
			console.error("error in update doc ===", error);
			return error;
		});
	}

	static executeJob(data) {
		let uri = API_BASE_URL + "/jobs/execute/" + data.dataModelId;

		return Request(uri, {
			url: uri,
			method: "POST",
			headers: {
				appId: data.appid,
			},
			payload: data.data
		}).then(response => {
			return response
		}).catch(error => {
			console.error("error in update doc ===", error);
			return error;
		});
	}
}